import { Observable } from 'rxjs';
import { LazyCommonBootstrapCSRService } from './services/lazy-common-bootstrap.csr.service';
import { lazyService } from '@lentau/ui-kit/core/helpers/lazy-service';

export const LazyLoadCommonBootstrap: () => Observable<LazyCommonBootstrapCSRService> = () =>
  lazyService(() =>
    import('./services/lazy-common-bootstrap.csr.service').then((m) => m.LazyCommonBootstrapCSRService)
  );
